export default __webpack_public_path__ + "static/media/logo.b4b399b5.png";